import { render, staticRenderFns } from "./FeedAlertNoResponse.vue?vue&type=template&id=3633dcfe"
import script from "./FeedAlertNoResponse.vue?vue&type=script&lang=js"
export * from "./FeedAlertNoResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports